import { styled } from '@mui/material/styles';
import { ToggleButton, toggleButtonClasses } from '@mui/material';
import { color as token } from '@figma/fpl-tokens/tokens.stylex';
import { color } from '@/colors';

interface PropertyToggleButtonProps {
  btnW?: string | number;
  btnH?: string | number;
}

export const PropertyToggleButton = styled(ToggleButton, {
  // oxlint-disable-next-line typescript/no-unnecessary-type-assertion -- MUI types this prop as PropertyKey.
  shouldForwardProp: (prop) => !['btnW', 'btnH'].includes(prop as string),
})<PropertyToggleButtonProps>(({ btnW, btnH }) => ({
  height: btnH || '26px',
  width: btnW || '29.333px',
  minWidth: btnW || '29.333px',
  padding: '6px',
  cursor: 'pointer',
  backgroundColor: 'transparent',
  border: 'none !important',
  borderRadius: '3px',
  '&:hover': {
    backgroundColor: token.bgTransparent,
  },
  [`&.${toggleButtonClasses.selected}`]: {
    backgroundColor: token.bgSecondary,
    '&:hover': {
      backgroundColor: token.bgSecondary,
    },
  },
  [`&.${toggleButtonClasses.disabled}`]: {
    backgroundColor: color.Black04,
    color: color.Black40,
  },
  '& svg': {
    color: token.textSecondary,
  },
  [`&.${toggleButtonClasses.selected} svg`]: {
    color: token.text,
  },
  [`&.${toggleButtonClasses.disabled} svg`]: {
    color: token.textSecondary,
  },
}));
